var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menuLateralDrawer)?_c('div',{staticClass:"wall",on:{"click":function($event){return _vm.toggleMenu()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }